import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from './../../services/index';
import { NotificationsService } from 'angular2-notifications';
import { app_version } from './../../../environments/version';
import { AuthHelper } from '../../shared/auth-helper';

@Component({
  selector: 'app-token-login',
  templateUrl: './token-login.component.html',
  styleUrls: ['./token-login.component.scss']
})
export class TokenLoginComponent implements OnInit {
  version: string;

  constructor(
    private activeRoute: ActivatedRoute,
    private notificationService: NotificationsService,
    private authenticationService: AuthenticationService,
    private router: Router
    ) {
    this.activeRoute.queryParams.subscribe(params => {

      if(!params.idToken){
        this.notificationService.error('Missing token information, redirecting you to login in 5 seconds');

        setTimeout(() => {
          this.router.navigate(['/login']);
        }, 5000);
      }
      else
      {
        console.log("token=" + params.idToken);

        this.authenticationService.tokenLogin(params.idToken)
        .subscribe(result => {
          if (result === true) {

            this.notificationService.success('Welcome ' + AuthHelper.GetUserFullName(), 'You are logged in successfully');

            if (AuthHelper.IsAdmin()) {
              this.router.navigate(['/admin/carrier/database']);
            } else if (AuthHelper.IsCarrierAdmin()) {
              this.router.navigate(['/admin/carrier/overview/0']);
            } else if (AuthHelper.IsDriver()) {
              this.router.navigate(['/driver/home']);
            } else if (AuthHelper.IsRecordKeeper()) {
              this.router.navigate(['/recordkeeper/home']);
            }
          } else {
            this.notificationService.error('Login not successful.  The token is not valid');
          }
        },
        error => {
          this.notificationService.error('Login not successful. The email or password provided is incorrect');
        });

      }

		});
  }

  ngOnInit(): void {
    this.version = app_version;
      }
}
